<template>
  <a-card :bordered="false">
    <!-- 上部功能导航 -->
    <div v-show="roleId === config.RoleType.SUPER_ADMIN">
      <div class="table-operator">
        <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
        <!-- <a-divider type="vertical" />
        <a-button type="primary" icon="inbox" @click="update()">保存更改</a-button> -->
      </div>
      <br/><br/>
    </div>

    <div>
      <a-tabs tabPosition="left" size="large">
        <a-tab-pane v-for="(item, i) in datalist" :tab="item.typeName" :key="item.type">
          <div v-for="(s, j) in item.data" class="sdiv">
            <div class="stitle">{{s.title}}</div>
            <div class="svalue">
              <a-input-number v-if="s.dataType == 'double'" :ref="s.id" v-model="s.value" @blur="compelChange(i, j, s.id)" style="width: 100%"/>
              <a-switch v-else-if="s.dataType == 'boolean'" :ref="s.id" v-model="s.value" @change="compelChange(i, j, s.id)" />
              <a-input v-else-if="s.dataType == 'string'" :ref="s.id" v-model="s.value" @blur="compelChange(i, j, s.id)" @change="showChange(i, j, s.id)" />
              <a-select v-else-if="s.dataType == 'select'" :ref="s.id" v-model="s.value" @change="compelChange(i, j, s.id)" style="width: 100%;">
                <a-select-option v-for="(ct, index) in $store.getters.codeList[s.codeType]" :key="index" :value="ct.value" >{{ ct.name }}</a-select-option>
              </a-select>
            </div>
            <div class="saction" v-show="roleId === config.RoleType.SUPER_ADMIN">
              <a @click="handleDel(s.id)">删除</a>
            </div>
            <br/>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>

    <a-modal
      title="添加"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="标题" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder="标题"
            v-decorator="['title',
            { initialValue: mdl.title, rules: [{ required: true, message: '请输入标题'}]}]"
          />
        </a-form-item>

        <a-form-item label="键(key)" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder="键(key)"
            v-decorator="['key',
            { initialValue: mdl.key, rules: [{ required: true, message: '请输入键(key)'}]}]"
          />
        </a-form-item>

        <a-form-item label="值" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder="值"
            v-decorator="['value',
            { initialValue: mdl.value, rules: [{ required: true, message: '请输入值'}]}]"
          />
        </a-form-item>

        <a-form-item label="设置类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            placeholder="设置类型"
            v-decorator="['type',
            { initialValue: mdl.type, rules: [{ required: true, message: '请选择设置类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in typeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="数据类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            placeholder="数据类型"
            v-model="mdl.dataType" 
            v-decorator="['dataType',
            { initialValue: mdl.dataType, rules: [{ required: true, message: '请选择数据类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in dataTypeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="字典类型Code" v-if="mdl.dataType == 'select'" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder="字典类型Code"
            v-decorator="['codeType',
            { initialValue: mdl.codeType, rules: [{ required: true, message: '请输入字典类型Code'}]}]"
          />
        </a-form-item>

        <a-form-item label="参数等级" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            placeholder="参数等级"
            v-decorator="['level',
            { initialValue: mdl.level, rules: [{ required: true, message: '请选择参数等级'}]}]"
          >
            <a-select-option
              v-for="(item, index) in levelSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="备注" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-textarea placeholder="备注" v-model="mdl.remark" :autosize="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>
      </a-form>
    </a-modal>
    
  </a-card>
</template>

<script>
import { settingsList, settingUpdateBatch, settingsUpdate, settingsSave, settingsDelete } from '@/api/sys'

export default {
  name: 'settings',
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      mdl: {},
      datalist: [],
      roleId: null,
      typeSelect: null,
    }
  },
  created() {
    this.roleId = this.$store.getters.roles
    this.typeSelect = this.$store.getters.codeList.sys_terminal_type
    this.dataTypeSelect = this.$store.getters.codeList.sys_settings_data_type
    this.levelSelect = this.$store.getters.codeList.sys_settings_level
    this.initdata()
  },
  methods: {
    // vue的v-model遇到嵌套变量无法自动改变显示，这里使用手动更新
    initdata() {
      new Promise(resolve => {
        const data = settingsList().then(res => { return res.data })
        resolve(data)
      }).then(res => {
        // 先把list<map>结构转成map<list<map>>
        let transferMap = new Map()
        for (let i = 0; i < res.length; i++) {
          if (this.roleId === this.config.RoleType.SUPER_ADMIN || (this.roleId === this.config.RoleType.ADMIN && res[i].level >= 1) ||
              (this.roleId != this.config.RoleType.SUPER_ADMIN && this.roleId != this.config.RoleType.ADMIN && res[i].level >= 2)) {
            if (transferMap[res[i].type]) {
              let transfer = transferMap[res[i].type]
              transfer.push(res[i])
              transferMap[res[i].type] = transfer
            } else {
              let transfer = [res[i]]
              transferMap[res[i].type] = transfer
            }
          }
        }
        // 再把map<list<map>>转换成list<map<list<map>>>结构
        let list = []
        for(let key in transferMap){
          let map = new Map()
          if (transferMap[key]) {
            map["type"] = transferMap[key][0].type
            map["typeName"] = transferMap[key][0].typeName
            map["data"] = transferMap[key]
            for (let j = 0; j < transferMap[key].length; j++) {
              // 把布尔类型的数值字符串转成布尔类型，适配控件参数
              if (transferMap[key][j].dataType == 'boolean') {
                if (transferMap[key][j].value == '1') {
                  transferMap[key][j].value = true
                } else {
                  transferMap[key][j].value = false
                }
              }
            }
            list.push(map)
          }
        }
        this.datalist = list
        // console.log(this.datalist)
      })
    },
    showChange(i, j, id) {
      this.$refs[id][0].value = this.datalist[i]['data'][j]['value']
    },
    compelChange(i, j, id) {
      if (this.datalist[i]['data'][j]) {
        if (this.datalist[i]['data'][j]['dataType']  == 'boolean') {
          this.$refs[id][0].checked = this.datalist[i]['data'][j]['value']
        } else {
          this.$refs[id][0].value = this.datalist[i]['data'][j]['value']
        }
        // this.update()
        let value = this.datalist[i]['data'][j]['value']
        if (this.datalist[i]['data'][j]['dataType'] == 'boolean') {
          if (value) {
            value = '1'
          } else {
            value = '0'
          }
        }
        settingsUpdate({"id": this.datalist[i]['data'][j]['id'], "value": value})
        .then().catch(e => { console.log(e) })
      }
    },
    update() {
      // 数据格式处理
      // console.log(this.datalist)
      this.confirmLoading = true
      let slist = []
      for (let i = 0; i < this.datalist.length; i++) {
        if (this.datalist[i] && this.datalist[i]['data']) {
          for (let j = 0; j < this.datalist[i]['data'].length; j++) {
            let o = this.datalist[i]['data'][j]
            let map = {}
            map['id'] = o['id']
            // 此处遇到布尔类型再转成字符串
            if (o['dataType'] == 'boolean') {
              if (o['value']) {
                map['value'] = '1'
              } else {
                map['value'] = '0'
              }
            } else {
              map['value'] = o['value']
            }
            slist.push(map)
          }
        }
      }
      // console.log(slist)
      settingUpdateBatch(slist).then(res =>{
        if (res.code === '0') {
          // this.$refs.table.refresh()
          // this.visible = false
        }
      }).catch(e => {
        console.log(e)
      })
      .finally(() => {
        this.confirmLoading = false
      })
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        Object.assign(this.mdl, values)
        if (!err) {
          this.confirmLoading = true
          settingsSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.initdata()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
        }
      })
    },
    handleDel(id) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          nthis.confirmLoading = true
          return settingsDelete({ ids: id })
            .then(res => {
              if (res.code === '0') {
                nthis.initdata()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
  }
}
</script>
<style>
.sdiv{
  margin-bottom: 20px;
  height: 30px;
  line-height: 30px
}
.stitle{
  width: 20%;
  float: left;
  text-align: right;
  padding-right: 2%;
}
.svalue{
  width: 30%;
  float: left;
  text-align: left;
}
.saction{
  width: 10%;
  float: left;
  text-align: left;
  padding-left: 2%;
}

</style>